import { render } from "./CompanyIntro.vue?vue&type=template&id=4d6c3ffc&scoped=true"
import script from "./CompanyIntro.vue?vue&type=script&lang=js"
export * from "./CompanyIntro.vue?vue&type=script&lang=js"

import "./CompanyIntro.vue?vue&type=style&index=0&id=4d6c3ffc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d6c3ffc"]])

export default __exports__